// extracted by mini-css-extract-plugin
export default {"dzen":"dzen_dzen__1g-CS"};